import { render, staticRenderFns } from "./StackBar.vue?vue&type=template&id=313fa58c&scoped=true&"
import script from "./StackBar.vue?vue&type=script&lang=js&"
export * from "./StackBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313fa58c",
  null
  
)

export default component.exports